import React, { ReactNode, FunctionComponent } from 'react';
import classnames from 'classnames';
import { useUID } from 'dibs-uid';
import { useIntl, defineMessages } from 'react-intl';

import Close from 'dibs-icons/exports/Close';
import { Link } from '../Link';

// styles
import styles from './main.scss';

const messages = defineMessages({
    deleteLabel: { id: 'SearchTag.deleteLabel', defaultMessage: 'Delete' },
});

type SearchTagProps = {
    isActive?: boolean;
    disabled?: boolean;
    onDelete?: () => void;
    dataTn?: string;
    children: ReactNode;
    hasDeleteButton?: boolean;
};
export const SearchTag: FunctionComponent<SearchTagProps> = props => {
    const {
        isActive = true,
        disabled = false,
        onDelete = () => {},
        dataTn,
        children,
        hasDeleteButton = true,
    } = props;

    const uid = useUID() || undefined;
    const intl = useIntl();

    const tagClassName = classnames(styles.searchTag, {
        [styles.searchTagEnabled]: !disabled,
        [styles.searchTagActive]: isActive && !disabled,
    });
    const deleteClassName = classnames(styles.deleteButton, {
        [styles.deleteButtonEnabled]: !disabled,
    });
    const labelClassNames = classnames(styles.searchTagLabel, {
        [styles.noDeleteButton]: !hasDeleteButton,
    });
    const deleteClick = disabled ? () => {} : onDelete;
    return (
        <div className={styles.searchTagWrapper}>
            <div className={tagClassName} data-tn={dataTn}>
                <div id={uid} className={labelClassNames}>
                    {children}
                </div>
                {hasDeleteButton && (
                    <Link
                        ariaDescribedBy={uid}
                        ariaLabel={intl.formatMessage(messages.deleteLabel)}
                        className={deleteClassName}
                        onClick={deleteClick}
                    >
                        <Close className={styles.closeIcon} />
                    </Link>
                )}
            </div>
        </div>
    );
};
